module.exports = __webpack_public_path__ + "static/media/minion.12a3f1f4.png";